//
//
//
//
//
//
//
//
//
//

import { getUserItem } from '@/api/lottery.js'
export default {
  data () {
    return {
      lotid: this.$route.params.lotid,
      prizelist: []
    }
  },
  computed: {
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    this.getWinning()
  },
  methods: {
    // 获取中奖列表
    getWinning () {
      getUserItem({
        openid: this.userid,
        lotid: this.lotid
      }).then(res => {
        this.prizelist = res.obj.items
      })
    }
  }
}
